"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var core_1 = require("@material-ui/core");

var autobind_decorator_1 = __importDefault(require("autobind-decorator"));

var Datatable_1 = require("../Datatable");

var styles = function styles(t) {
  return core_1.createStyles({
    root: {
      background: t.palette.background.default,
      borderBottom: "1px solid " + t.palette.divider,
      minHeight: 48,
      paddingRight: t.spacing.unit * 2,
      paddingLeft: t.spacing.unit * 2
    },
    hiddenBadge: {
      display: 'none'
    },
    menuItem: {
      paddingTop: t.spacing.unit,
      paddingRight: t.spacing.unit,
      paddingBottom: t.spacing.unit,
      paddingLeft: 0
    }
  });
};

var DatatableColumnsFilter =
/** @class */
function (_super) {
  __extends(DatatableColumnsFilter, _super);

  function DatatableColumnsFilter() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      anchorEl: null
    };
    return _this; // private allColumnsHidden(): boolean {
    //   const {hiddenColumnsIndexes} = this.props
    //   return hiddenColumnsIndexes.length > 0 && hiddenColumnsIndexes.every(i => i === false)
    // }
  }

  DatatableColumnsFilter.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        columns = _a.columns,
        isColumnVisible = _a.isColumnVisible,
        classes = _a.classes;
    return React.createElement("div", null, React.createElement(core_1.IconButton, {
      onClick: this.open
    }, React.createElement(core_1.Icon, null, "remove_red_eye")), React.createElement(core_1.Menu, {
      anchorEl: this.state.anchorEl,
      open: !!this.state.anchorEl,
      onClose: this.close
    }, columns.map(function (c, i) {
      return React.createElement(core_1.MenuItem, {
        key: i,
        onClick: _this.pick(i),
        className: classes.menuItem
      }, React.createElement(core_1.Checkbox, {
        checked: isColumnVisible(i)
      }), c.label);
    })));
  };

  DatatableColumnsFilter.prototype.pick = function (index) {
    var onToggleColumnVisibility = this.props.onToggleColumnVisibility;
    return function () {
      return onToggleColumnVisibility(index);
    };
  };

  DatatableColumnsFilter.prototype.open = function (event) {
    this.setState({
      anchorEl: event.currentTarget
    });
  };

  DatatableColumnsFilter.prototype.close = function () {
    this.setState({
      anchorEl: null
    });
  };

  __decorate([autobind_decorator_1.default], DatatableColumnsFilter.prototype, "pick", null);

  __decorate([autobind_decorator_1.default], DatatableColumnsFilter.prototype, "open", null);

  __decorate([autobind_decorator_1.default], DatatableColumnsFilter.prototype, "close", null);

  return DatatableColumnsFilter;
}(React.Component);

exports.default = Datatable_1.datatableConsumer(core_1.withStyles(styles)(DatatableColumnsFilter));